import React, { useEffect, useRef, useState } from 'react'
import "./index.css";
import { Link, useNavigate } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";
import { baseURL } from '../../api/api';
import superAdminApis from '../../api/services/admin-pages/superAdmin';
import { toast } from 'react-toastify';
import CommonPagination from '../../components/pagination';
import translations from '../../shared/Translations';
import { FaUserCircle } from 'react-icons/fa';

function CustomerList() {

  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [submit, setSubmit] = useState(false);
  const [customerDeleteId, setCustomerDeleteId] = useState("")
  const [customerName, setCustomerName] = useState("")
const [pageSizes, setPageSizes] = useState([]);

  const baseUrl = baseURL

  // const [customerList,setCustomerList] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  // const [recordsPerPage] = useState(10);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [userDeleteId, setUserDeleteId] = useState("");
  const [userName, setUserName] = useState('')
  const [customerList, setCustomerList] = useState([]);

  const handleAddCustomer = () => {
    navigate('/customer-details')
  }

  const [searchTerm, setSearchTerm] = useState(
    sessionStorage.getItem("customerSearch") || ""
  );


  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: true,
    });
  }, []);


  const loginModalRef = useRef(null);
   const existingModalRef = useRef(null);

  // open main login modal
  const openLoginModal = () => {
    const modal = new window.bootstrap.Modal(loginModalRef.current);
    modal.show();
  };

    // open existing customer modal
  const openExistingCustomerModal = () => {
    const modal = new window.bootstrap.Modal(existingModalRef.current);
    modal.show();
  };

  const handleNewCustomer = () => {
    const modal = window.bootstrap.Modal.getInstance(loginModalRef.current);
    modal.hide(); // close main modal
    navigate("/customer-details/create");
  };


  const handleBackCustomer = () => {
    navigate("/dashboard");
  };



  const handleExistingLogin = async () => {
    setSubmit(true);

    const phoneRegex = /^[6-9]\d{9}$/;

    // Validation
    if (!phone.trim()) return; 
    if (!phoneRegex.test(phone)) return; 

    setLoading(true);

    const apiData = { phoneNo: phone };

    try {
      const responseData = await superAdminApis.customerPhoneLoginAPI(apiData);

      if (responseData.apiStatus?.code === "200") {
        const customerData = responseData.result;
        toast.success(responseData.apiStatus.message || "Login successful!");
        document.getElementById("closeModal")?.click();
        navigate("/customer-details/create", { state: { customer: customerData } });
      } else {
        toast.error(responseData.apiStatus?.message || "Login failed!");
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error("An error occurred during login.");
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    handleUserList(currentPage)
  }, [currentPage, searchTerm,recordsPerPage]);


  const handleUserList = (page) => {
    setLoading(true);

    const apiData = {
      pageIndex: page - 1,
      dataLength: recordsPerPage,
      searchName: searchTerm
    };

    superAdminApis.customerDetailsList(apiData)
      .then((responseData) => {
        if (responseData?.apiStatus?.code === "200") {
          setLoading(false);
          setCustomerList(responseData?.result?.customerDetails || []);
          setTotalRecords(responseData?.result?.totalRecordCount || 0);
const sizes = responseData?.result?.totalSort;

console.log(sizes);


setPageSizes(
  Array.isArray(sizes)
    ? sizes
    : []
);
          console.log(typeof responseData?.result?.totalSort);
console.log(responseData?.result?.totalSort);
          
        } else {
          setCustomerList([]);
          setLoading(false);
          // toast.error(responseData?.apiStatus?.message || "Failed to fetch data");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching customer details:", error);
        toast.error("An error occurred while fetching data.");
      });
  };



  // Customer Delete


  const handleDeleteCustomer = () => {
    superAdminApis.customerDetailsDeleteAPI(customerDeleteId)
      .then((responseData) => {
        if (responseData.apiStatus.code === '200') {
          const newTotalRecords = totalRecords - 1;
          setTotalRecords(newTotalRecords);
          let totalPages = Math.ceil(newTotalRecords / recordsPerPage);
          if (currentPage > totalPages) {
            setCurrentPage(totalPages || 1);
          }
          else if (currentPage < 1) {
            setCurrentPage(1);
          }
          const closeButton = document.getElementById("closedeleteModal");
          if (closeButton) {
            handleUserList(currentPage);
            closeButton.click();
          }
          toast.success(responseData?.apiStatus?.message);
        } else {
          toast.error(responseData?.apiStatus?.message);
        }
      })
      .catch((error) => {
        setLoading(false)
        console.error("Error during login:", error);
        toast.error("An error occurred during login.");
      });
  };

  const totalPages = Math.ceil(totalRecords / recordsPerPage);

  console.log(currentPage, totalPages);
  


  const onPageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  useEffect(() => {
    const savedSearch = sessionStorage.getItem("customerSearch");
    if (savedSearch) {
      setSearchTerm(savedSearch);
    }
  }, []);

  
    const [lang, setLang] = useState("en");
 const t = (key) => translations[lang][key] || key;

 useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang) setLang(savedLang);
  }, []);

 

  return (

    <div>
      <div className="d-flex justify-content-between align-items-center mt-3 mb-4">

        {/* Left side (Breadcrumb) */}
        <nav aria-label="breadcrumb" className={lang === "ta" ? "fs-tamil" : ""}>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="#" onClick={handleBackCustomer}>  {t("dashboard")}</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {t("customerList")}
            </li>
          </ol>
        </nav>



      </div>

      <div className='customer-list-container card'>

       <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-2 mb-4">
  
  <h5 className={`heading-with-line mb-2 mb-md-0 aquanew-text-effect ${lang === "ta" ? "fs-tamil" : ""}`}>
    <i className="bi bi-people-fill me-1"></i>
  {t("customerList")}
    <span className="smooth-line"></span>
  </h5>

  <div className="search-container mx-auto mb-2 mb-md-0">
    <input
      type="text"
     className={`form-control search-input ${lang === "ta" ? "fs-tamil" : ""}`}
      placeholder= {t("searchPlaceholder")}
      value={searchTerm}
      
      onChange={(e) => {
        setSearchTerm(e.target.value);
        sessionStorage.setItem("customerSearch", e.target.value);
      }}
    />
  </div>

  <div className="d-flex gap-2">
    <button className="btn add-customer" onClick={openLoginModal}>
      <i className="fa fa-sign-in me-2"></i>
      {t("customerLogin")}
    </button>
  </div>

</div>

        {/* Table Content */}

     <div className="mt-4 table-section ">
 <div className="table-responsive">
          <table className="table table-striped table-bordered" data-aos="fade-up">
            <thead  className="table-light">
            <tr className={lang === "ta" ? "fs-tamil" : ""}>
    <th>{t("slNo")}</th>
    <th>{t("loanId")}</th>
    <th>{t("name")}</th>
    <th>{t("date")}</th>
    <th>{t("loanAmount")}</th>
    <th>{t("interest")}</th>
    <th>{t("remaining")}</th>
    <th className="text-center">{t("status")}</th>
    <th className="text-center">{t("actions")}</th>
  </tr>
            </thead>


<tbody>
  {loading ? (
    <tr>
      <td colSpan="10" className="text-center">
        <div className="gold-dots-loader">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </td>
    </tr>
  ) : customerList && customerList.length > 0 ? (
    customerList?.map((customer, index) => (
      <tr key={customer?.id || index} className="customer-table-td">
        <td>
          {(currentPage - 1) * recordsPerPage + index + 1}
        </td>

        <td>{customer?.loan_id || "-"}</td>
        <td>{customer?.name || "-"}</td>
                             <td>
  {customer.date 
    ? customer.date.split(" ")[0].split("-").reverse().join("-")
    : "-"
  }
</td>
        <td>{customer?.loan_amount || "-"}</td>
        <td>{customer?.intrest_rate || "-"}</td>
        <td>{customer?.balance || "-"}</td>

         <td className="text-center align-middle">
  {customer?.paid_status === "Closed" ? (
    <span className="badge bg-danger">{t("closedTable")}</span>
  ) : (
    <span className="badge bg-success">{t("active")}</span>
  )}
</td>

        <td className="text-center" style={{ width: "10rem" }}>
          <div className="action-buttons-wrapper">
            <div className="action-buttons">
              <Link
                to={`/customer-view/${customer?.id}`}
                className="btn-view view-btn"
                 data-tooltip="View"
              >
                👁️
              </Link>

              <Link
                to={`/customer-details/edit/${customer?.id}`}
                className="btn-view edit-btn"
                data-tooltip="Edit"
              >
                ✏️
              </Link>

              <Link
                to={`/customer-pay/${customer?.id}`}
                className="btn-view pay-btn"
                 data-tooltip="Pay"
              >
                💰
              </Link>
            </div>

            <button
              className="btn-view delete-btn"
              data-bs-toggle="modal"
              data-bs-target="#customerDelete"
              onClick={() => {
                setCustomerDeleteId(customer?.id);
                setCustomerName(customer?.name);
              }}
               data-tooltip="Delete"
            >
              🗑️
            </button>
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="10" className={`text-center ${lang === "ta" ? "fs-tamil" : ""}`}>
  {t("noRecords")}
</td>
    </tr>
  )}
</tbody>

          </table>
          
        </div>

 <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">

  {/* LEFT SIDE */}
  <div className="d-flex align-items-center gap-2">
    <select
      className="form-select form-select-sm"
      style={{ width: "80px" }}
      value={recordsPerPage}
      onChange={(e) => setRecordsPerPage(Number(e.target.value))}
    >
        {pageSizes?.map((size) => (
    <option key={size} value={size}>
      {size}
    </option>
  ))}
    </select>

   <span className={lang === "ta" ? "fs-tamil" : ""}>
  {t("showing")} {(currentPage - 1) * recordsPerPage + 1} -{" "}
  {Math.min(currentPage * recordsPerPage, totalRecords)} {t("of")}{" "}
  {totalRecords}
</span>
  </div>

  {/* RIGHT SIDE */}
  <div>
    <CommonPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
    />
  </div>

</div>
        </div>
       

        {/* 🔹 Main Login Modal */}

        <div
          className="modal fade"
          tabIndex="-1"
          ref={loginModalRef}
          aria-labelledby="loginModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                 <h6 className={`modal-title ${lang === "ta" ? "fs-tamil" : ""}`} id="loginModalLabel">
          {t("loginOptions")}
        </h6>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body text-center new-customer-modal">
                <p className={lang === "ta" ? "fs-tamil" : ""}>
          {t("selectCustomerType")}
        </p>
                <div className="d-flex justify-content-center gap-3 mt-3">
                   <button
            type="button"
            className={`btn handleNewCustomer ${lang === "ta" ? "fs-tamil" : ""}`}
            onClick={handleNewCustomer}
          >
            {t("newCustomer")}
          </button>

                  <button
            type="button"
            className={`btn existingCustomer ${lang === "ta" ? "fs-tamil" : ""}`}
            onClick={() => {
              const modal =
                window.bootstrap.Modal.getInstance(loginModalRef.current);
              modal.hide();
              openExistingCustomerModal();
            }}
          >
            {t("existingCustomer")}
          </button>
                </div>
              </div>
            </div>
          </div>
        </div>


              {/* 🔹 Existing Customer Login Modal */}

<div
  className="modal fade"
  tabIndex="-1"
  ref={existingModalRef}
  aria-labelledby="existingCustomerLabel"
  aria-hidden="true"
>
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
         <h6 className={`modal-title ${lang === "ta" ? "fs-tamil" : ""}`} id="existingCustomerLabel">
          {t("existingLogin")}
        </h6>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            setSubmit(false); // reset validation when closing
            setPhone("");
            window.bootstrap.Modal.getInstance(existingModalRef.current)?.hide();
          }}
          aria-label="Close"
          id="closeModal"
        >

          
        </button>
      </div>

      <div className="modal-body">
     <div className="mb-3">
 <label
            htmlFor="phoneNumber"
            className={`form-label required-star ${lang === "ta" ? "fs-tamil" : ""}`}
          >
            {t("phoneNumber")}
          </label>
 <input
  type="tel"
  id="phoneNumber"
  className={`form-control ${lang === "ta" ? "fs-tamil" : ""}`}
            placeholder={t("enterPhone")}
  value={phone}
  maxLength="10"
  onChange={(e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) setPhone(value);
  }}
  style={
    (submit && phone.length === 0) || 
    (phone.length > 0 && !/^[6-9]\d{9}$/.test(phone))
      ? { borderColor: "red" }
      : {}
  }
/>

{/* Error messages */}
{submit && phone.length === 0 && (
  <div className="text-danger">{t("phoneRequired")}</div>
)}

{phone.length > 0 && phone.length < 10 && (
  <div className="text-danger">{t("phoneInvalid")}</div>
)}

{phone.length === 10 && !/^[6-9]/.test(phone) && (
  <div className="text-danger">{t("phoneStart")}</div>
)}

</div>



        <div className="text-center">
          <button
            type="button"
            className="btn add-customer"
            onClick={handleExistingLogin}
          >
           {t("login")}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


{/* Delete Modal */}

 <div
  className="modal fade"
  id="customerDelete"
  tabIndex="-1"
  aria-labelledby="deleteModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">

      <div className="modal-header text-white" style={{background:"#7FB77E"}}>
        <h6 className={`modal-title ${lang === "ta" ? "fs-tamil" : ""}`} id="deleteModalLabel">
          {t("confirmDelete")}
        </h6>

        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          id="closedeleteModal"
        ></button>
      </div>

      <div className={`modal-body text-center ${lang === "ta" ? "fs-tamil" : ""}`}>
        {t("deleteMessage")}{" "}
        <span className="delete-customer-name">{customerName}</span> ?
      </div>

      <div className="modal-footer justify-content-center">

        <button
          type="button"
          className={`btn add-customer ${lang === "ta" ? "fs-tamil" : ""}`}
          onClick={handleDeleteCustomer}
        >
          {t("yesDelete")}
        </button>

        <button
          type="button"
          className={`btn btn-secondary ${lang === "ta" ? "fs-tamil" : ""}`}
          data-bs-dismiss="modal"
        >
          {t("cancel")}
        </button>

      </div>

    </div>
  </div>
</div>


      </div>
    </div>





  )
}

export default CustomerList
